import { defineInterface } from '@nzyme/ioc/Interface.js';
/**
 * Provides current language.
 */
export const LanguageContext = defineInterface({
    name: 'LanguageContext',
});
//# sourceMappingURL=LanguageContext.js.map